import { DSConfigurationService } from '@trp-dms-digital-shared/ds-ui-library-components/src/lib/configuration/digital-shared-configuration.service.js';
import { SingletonService } from '@trp-dms-digital-shared/ds-ui-library-common';
import { Constants } from '../../base/base.constants';

@SingletonService
export class PopConfiguration {
  digitalSharedConfigurationService: DSConfigurationService;

  constructor() {
    this.digitalSharedConfigurationService = new DSConfigurationService();
  }

  public addConfiguration(key: string, configuration: unknown): void {
    this.digitalSharedConfigurationService.addConfiguration(key, configuration);
  }

  public getConfiguration(key: string): unknown {
    return this.digitalSharedConfigurationService.getConfiguration(key);
  }

  public getAssetBaseUrl(): string {
    const popConfiguration = new PopConfiguration();
    const assetsDomain = popConfiguration.getConfiguration(
      Constants.ASSETS_DOMAIN,
    );
    const productComponentLibraryVersion = popConfiguration.getConfiguration(
      Constants.PRODUCT_COMPONENT_LIBRARY_VERSION,
    );
    if (assetsDomain && productComponentLibraryVersion) {
      return `${assetsDomain}/products/product-ui/product-component-library/${productComponentLibraryVersion}/packages/components`;
    } else {
      // If the configs aren't set we are probably using storybook or something, so assume it's the current URL
      return '.';
    }
  }
}
